import { atom } from "recoil";

export const SearchTermState = atom<string>({
  key: "searchTermState",
  default: "",
});
